import React, { useState, useCallback } from 'react'
import { Form } from 'antd'
import { Modal } from '../../components/modals/antd-modals'
import { Tab1 } from './overview/tabs/tab1'
import { CREATE_BRANCH_OFFICE } from '../../graphql/AdminMutations'
import { setAllBranchOfficces } from '../../redux/branchOfficces/actionCreator'
import displayNotification from '../reservation/admin/notification/notification'
import { useDispatch } from 'react-redux'
import { useMutation } from '@apollo/client'

const NewRecordModal = props => {
  const { t, gridState, handleCancel, onCancel, tableData } = props

  const dispatch = useDispatch()
  const graphqlVariables = {
    tokenMutation: process.env.REACT_APP_TOKEN_MUTATION
  }
  const [triggerCreateCompany] = useMutation(CREATE_BRANCH_OFFICE, {
    variables: graphqlVariables
  })

  const handleEditOk = newCompany => {
    onCancel()

    let newData = [...tableData]
    newCompany.id = tableData.length + 1
    newData.push(newCompany)
    const variables = {
      ...graphqlVariables,
      active: true,
      firstname: newCompany.firstname,
      lastname: newCompany.lastname,
      company: newCompany.company,
      zip: newCompany.zip,
      street: newCompany.street,
      city: newCompany.city,
      phone: newCompany.phone,
      email: newCompany.email,
      ic: newCompany.ic,
      dic: newCompany.dic,
      ic_dph: newCompany.ic_dph,
      send_reservation_email: newCompany.send_reservation_email,
      note: newCompany.note
    }

    triggerCreateCompany({ variables }).then(({ data }) => {
      let type = 'success'
      const message = t('backend.notifications.create')
      let desc = t('backend.notifications.success.recordCreate')
      if (data.createBranchOffice !== undefined) {
        dispatch(setAllBranchOfficces(newData))
      } else {
        type = 'error'
        desc = t('backend.notifications.error.recordCreate')
      }
      displayNotification(type, message, desc)
    })
  }

  const [form] = Form.useForm()

  return (
    <Modal
      type='primary'
      title={t('serviceActions.tableList.carRenter')}
      visible={gridState.addNewRecord}
      footer={null}
      onCancel={handleCancel}
      width={600}
    >
      <div className='project-modal'>
        <Tab1
          t={t}
          data={'selectedItem'}
          setState={'setState'}
          formReadonly={false}
          form={form}
          handleEditOk={handleEditOk}
        />
      </div>
    </Modal>
  )
}

export default NewRecordModal
